import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { CentralisedFAQs } from "./FAQs";
import { CentralisedKeyInfoBanner } from "./KeyInfoBanner/CentralizedKeyInfoBanner";
import { CentralisedKeyInfoList } from "./KeyInfoList/CentralizedKeyInfoList";

export const CentralizedFaqsTab = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    if (!activeTab) {
      navigate(`/centralized/centralizedFaqs?activeTab=centralizedQandAs`, {
        replace: true,
      });
    }
  }, [query.get("activeTab")]);
  const travellersInfoCard = [
    {
      label: "Q&As",
      key: "centralizedQandAs",
      children: <CentralisedFAQs />,
    },
    {
      label: "Categories (MYairports)",
      key: "centralizedFaqsCategories",
      children: <CentralisedKeyInfoList />,
    },
    {
      label: "Banner (MYairports)",
      key: "centralizedKeyInfoBanner",
      children: <CentralisedKeyInfoBanner />,
    },
  ];

  const handleProductManagement = (activeTab: any) => {
    if (activeTab === "centralizedQandAs") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedFaqs/centralizedQandAs/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Q&A
        </Button>
      );
    } else if (activeTab === "centralizedFaqsCategories") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedFaqs/centralizedFaqsCategories/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Category
        </Button>
      );
    }
    //  else if (activeTab === "centralizedKeyInfoBanner") {
    //   return (
    //     <Button
    //       onClick={() => {
    //         navigate("/centralized/centralizedFaqs/centralizedKeyInfoBanner/add?type=create");
    //       }}
    //       icon={<Icon icon={"lucide:plus"} />}
    //     >
    //       Add New Banner
    //     </Button>
    //   );
    // }
  };

  return (
    <ContentWrapper
      title={"FAQs"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(query.get("activeTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={travellersInfoCard}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
